import { render, staticRenderFns } from "./ThemeProvider.vue?vue&type=template&id=2ed2bd20&"
import script from "./ThemeProvider.vue?vue&type=script&lang=js&"
export * from "./ThemeProvider.vue?vue&type=script&lang=js&"
import style0 from "./ThemeProvider.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports